/*
 * supported languages
 */
import { SelectOption } from '../../../framework/valueobject/select-option.ts';

export enum Language {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  PL = 'pl',
  CS = 'cs',
  RM = 'rm',
  CHI = 'chi',
  IT = 'it',
}

function getLanguageString(language: string) {
  switch (language) {
    case Language.EN:
      return `English`;
    case Language.DE:
      return `Deutsch`;
    case Language.FR:
      return `Francais`;
    case Language.IT:
      return `Italiano`;
    case Language.PL:
      return `Polski`;
    case Language.CS:
      return `Čeština`;
    case Language.RM:
      return `Română`;
    case Language.CHI:
      return `中文 (zhōngwén)`;
    default:
      return language;
  }
}

export function getLanguageOptions(): SelectOption<Language>[] {
  return Object.values(Language).map((language) => ({
    label: getLanguageString(language),
    value: language,
  }));
}
